import PHONE_ICON from './../assets/images/home/phone_icon.png';
import HOME_LOGO from './../assets/images/home/home_logo.png';
import FlipperClock from './FlipperClock';

import './css/HomeQr.css';

const QR_IMAGE_URL = process.env.REACT_APP_QR_IMAGE_URL;

function HomeQr({ boardEndTime, showClock, setScoreFlag, setClockFlag, boardId }) {

    return (
        <div className="home-bg">
            <div className="booking-header">
                <div>
                    <img src={HOME_LOGO} alt="" style={{ width: '36vw', height: '15vw', marginLeft: '2vw' }} />
                </div>
                <div>
                    {
                        showClock ? (<FlipperClock boardEndTime={boardEndTime} setScoreFlag={setScoreFlag} setClockFlag={setClockFlag} />) : <></>
                    }
                </div>
                {
                    !showClock ? (<div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ fontSize: '5vw', fontWeight: 650, marginBottom: '0.9vw', fontFamily: 'Arial, sans-serif' }}>
                            For Booking
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={PHONE_ICON} style={{ width: '3.7vw', height: '3.7vw', marginRight: '2.5vw' }} alt="Icon" />
                            <div style={{ fontSize: '5.5vw', fontWeight: 650, marginRight: '3vw', fontFamily: 'Arial, sans-serif' }}>
                                8973138181
                            </div>
                        </div>
                    </div>) : <></>
                }

            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '2vw', marginTop: '2vw' }}>
                {
                    boardId ? (
                        <img
                            src={QR_IMAGE_URL + boardId + '.png'}
                            alt="QR Code"
                            style={{ height: '45vw', width: '50vw', borderRadius: '8px' }}
                        />
                    ) : (
                        <></>
                    )
                }
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
                <div style={{ marginBottom: '0.7vw', fontSize: '6.5vw', fontWeight: 900, fontFamily: 'Arial, sans-serif' }}>
                    {showClock ? "Let's Play" : "Scan Me For Live Score"}
                </div>
            </div>
        </div>
    );

}

export default HomeQr;